import { loadedDefinedMap, getValueFromValueProducer } from "../component-helpers";
import type {
    EnvironmentBoundEvaluable,
    RenderEnvironment,
    ActionResult,
    Context,
    ActionSource,
    Action} from "../types";
import {
    asAction
} from "../types";

export function evalAction(
    ctx: Context,
    actionSource: ActionSource,
    evaluable: EnvironmentBoundEvaluable | undefined
): Action | undefined {
    const vp = evaluable?.eval(ctx, actionSource);
    if (vp === undefined) return undefined;
    return loadedDefinedMap(getValueFromValueProducer(vp), asAction);
}

export async function evalAndRunAction(
    ctx: Context,
    env: RenderEnvironment,
    actionSource: ActionSource,
    evaluable: EnvironmentBoundEvaluable | undefined,
    handled?: boolean
): Promise<ActionResult | undefined> {
    const action = evalAction(ctx, actionSource, evaluable);
    return action?.run(ctx, env, actionSource, handled);
}
